export default class AkRelationResolver {

    /**
     * Resolve width the given type bundle and definition
     *
     * @param relation
     * @param currentType
     * @param currentBundle
     * @param currentDefinition
     * @param createElement
     * @param props
     * @param listeners
     * @param slots
     * @param data
     * @returns {*}
     */
    static resolve(relation, currentType,currentBundle, currentDefinition, createElement, { props, listeners, slots, data }, dataTableComponentType = null) {

        if(currentType === 'grid' || currentType === 'list') {
            // if we need to render a grid
            let leftOverRelationString = relation.length ? relation.join(':') : undefined;

            return createElement("ak-stacked-window", {
                class: data.staticClass,
                props: {
                    showClose: false,
                },
                on: {
                    close: listeners.close,
                },
                scopedSlots: {
                    default: childProps => createElement( dataTableComponentType ? dataTableComponentType :'ak-relation-data-table', {
                        props: {
                            type: currentType,
                            bundle: currentBundle,
                            definition: currentDefinition,
                            relation: props.relationReference,
                            defaultIdsSelected: props.defaultIdsSelected,
                            childRelationString: leftOverRelationString
                        },
                        on: {
                            save: listeners.updateRelations,
                            close: childProps.close,
                            refresh: listeners.updateRelations,
                        }
                    })
                }
            })
        } else if(currentType === 'form') {
            // if we have to render a form
            let currentObjectId = relation.shift();
            let leftOverRelationString = relation.length ? relation.join(':') : undefined;

            let width;
            const widthInStorage = localStorage.getItem(`${currentBundle}-${currentDefinition}-width`);
            if (widthInStorage) {
                width = widthInStorage;
            }

            const currentElement = createElement("ak-stacked-window", {
                class: data.staticClass,
                props: {
                    showClose: false,
                    resizable: true,
                    width: width,
                    minWidth: null,
                },
                ref: 'stackedWindow',
                on: {
                    close: listeners.close,
                    resize: (newWidth) => {
                        localStorage.setItem(`${currentBundle}-${currentDefinition}-width`, newWidth);
                    }
                },
                scopedSlots: {
                    default: childProps => createElement('ak-form', {
                        props: {
                            bundle: currentBundle,
                            definition: currentDefinition,
                            objectId: currentObjectId,
                            relationString: leftOverRelationString,
                        },
                        on: {
                            save: childProps.close,
                            cancel: childProps.close,
                            saveDataObject: (data) => {
                                if(!props.enableForeignList && data.dataObjectId &&  listeners.updateRelations) {
                                    listeners.updateRelations([data.dataObjectId]);
                                    return;
                                }
                                listeners.refresh([data.dataObjectId]);
                            },
                            minWidthChanged: (newMinWidth) => {
                                // dirty way to set the min width because we don't have a better option
                                currentElement.context.$refs['stackedWindow'].minWidth = newMinWidth;
                            }
                        },
                    })
                }
            });

            return currentElement;
        }
    }
}

Vue.component('ak-relation-resolver', {
    functional: true,
    name: "AkRelationResolver",
    props: {
        relationString: {
            type: String,
            default: '',
            required: true
        },
        relationReference: {
            type: String,
            default: '',
            required: false
        },
        enableForeignList: {
            type: Boolean,
            default: false,
            required: false,
        },
        defaultIdsSelected: {
            type: Array,
            required: false,
            default: () => {return []}
        }
    },
    render(createElement, data) {
        let relation = data.props.relationString.split(':');

        let currentType = relation.shift();
        let currentBundle = relation.shift();
        let currentDefinition = relation.shift();

        return AkRelationResolver.resolve(relation, currentType, currentBundle, currentDefinition, createElement, data);
    }
}, false);
